import {memo} from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import _isEqual from 'lodash/isEqual';
import DailyCalendarTile from './dailyCalendarTile/dailyCalendarTile';
import {calculateEventHeight, calculateEventLeft, calculateEventTop} from '../../../../../utils/edReviewUtils';
import {COLUMN_GAP, DEFAULT_LEFT, OFFSET, SLOT_HEIGHT} from '../edReviewCalendarDaily';

const ColumnEvents = ({ events, date, colWidth, onPatientSelect }) => !isEmpty(events) && (
  events.map((event, colIndex) => (
    <DailyCalendarTile
      key={`${event?.__id} + ${Math.random()} + ${event?.startDate}`}
      event={event}
      session
      onSelectTime={(ev) => onPatientSelect(ev, event, true)}
      options={{
        top: calculateEventTop({
          event,
          slotHeight: SLOT_HEIGHT,
          offset: OFFSET,
          eventDate: date,
        }),
        left: calculateEventLeft({
          event,
          columnIndex: colIndex,
          leftOffset: DEFAULT_LEFT,
          columnGap: COLUMN_GAP,
          eventSlotWidth: colWidth,
          offset: OFFSET,
        }),
        height: calculateEventHeight({
          event,
          eventSlotHeight: SLOT_HEIGHT,
          offset: OFFSET,
          eventDate: date,
          isReview: false,
        }),
        width: colWidth,
      }}
    />
  ))
);

ColumnEvents.propTypes = {
  date: PropTypes.string,
  events: PropTypes.array,
  colWidth: PropTypes.string,
  onPatientSelect: PropTypes.func,
};

export default memo(ColumnEvents, _isEqual);